import React from 'react';
import PropTypes from 'prop-types';
import styles from './Loader.module.scss';

export default function Loader(props) {
  return (
    props.active ?
    <div
      className={`${styles.loader} ${props.className}`}
      style={props.small ? {
        width: 10,
        height: 10,
        borderTopWidth: 2,
        borderBottomWidth: 2,
        borderLeftWidth: 2,
        borderRightWidth: 2,
      } : {}}
    ></div> :
    null
  );
}

Loader.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  small: PropTypes.bool
};
